import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import ContentServices from "../components/Services/ContentServices";
import BaseLayout from "../components/global/BaseLayout";

function Services() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="landscaping Services">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="landscaping Services"
          Subheader="landscaping Services"
          bgimg={`${rpdata?.gallery?.length > 9 ? rpdata?.gallery[9] : rpdata?.stock?.[9]}`}
        />
        <ContentServices/>
      </div>
    </BaseLayout>
  );
}

export default Services;
